import type { Components, Theme } from "@mui/material";

export const MuiDialog: Components<Theme>["MuiDialog"] = {
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				".MuiBackdrop-root": {
					backdropFilter: "blur(8px)",
					backgroundColor: "rgba(27,27,27,0.6)",
				},
				".MuiDialog-paper": {
					backgroundColor: theme.palette.background.default,
					borderRadius: theme.spacing(2),
					margin: theme.spacing(2),
					padding: theme.spacing(4),
					maxWidth: "36rem",
					width: "100%",
					[theme.breakpoints.up("xs")]: {
						gap: theme.spacing(3),
					},
					[theme.breakpoints.up("md")]: {
						gap: theme.spacing(4),
					},
				},
			}),
		},
	],
};

export const MuiDialogTitle: Components<Theme>["MuiDialogTitle"] = {
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				fontSize: theme.typography.pxToRem(24),
				fontWeight: 600,
				padding: 0,
			}),
		},
	],
};

export const MuiDialogContent: Components<Theme>["MuiDialogContent"] = {
	variants: [
		{
			props: {},
			style: { padding: 0 },
		},
	],
};

export const MuiDialogActions: Components<Theme>["MuiDialogActions"] = {
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				gap: theme.spacing(2),
				padding: 0,
				[theme.breakpoints.up("xs")]: {
					flexDirection: "column",
				},
				[theme.breakpoints.up("md")]: {
					flexDirection: "row-reverse",
				},
				".MuiButton-root": {
					margin: 0,
				},
			}),
		},
	],
};
